import React, { FunctionComponent, ReactElement } from 'react'
import './TopSection.scss'
import { isLiteraryApp, isUSAApp, isCanadaApp, isSanteApp } from '@models/AppType'
import { useTranslation } from 'react-i18next'
import datagotchiCharacter from '@assets/images/home/datagotchi.gif'
import datagotchiCharacterWithoutPet from '@assets/images/home/character-no-robot.gif'

import buildingsLeft from '@assets/images/home/buildings-left.png'
import USAHomepage from '@assets/images/home/home-image.png'
import CanadaHomepage from '@assets/images/home/home-canada.gif'
import SanteHomepage from '@assets/images/home/home-sante.png'
import buildingsRight from '@assets/images/home/buildings-right.png'

import backgroundBookSellers from '@assets/images/home/booksellers/booksellers-background-and-character.gif'

import './TopSection.scss'

export const TopSection: FunctionComponent = (): ReactElement => {
  const { t } = useTranslation('Home')

  if (isUSAApp) {
    return (
      <div className="HomePage-Header-ELECTIONS_USA">
        <img className="HomePage-Background" src={USAHomepage} alt={t('heroAltUsa')} />
        <img className="HomePage-Character" src={datagotchiCharacterWithoutPet} alt={t('title')} />
      </div>
    )
  }

  if (isLiteraryApp) {
    return (
      <div className="HomePage-Header-BOOKSELLERS">
        <img className="HomePage-Background-Character" src={backgroundBookSellers} alt={t('heroAltBooks')} />
      </div>
    )
  }

  if (isSanteApp) {
    return (
      <div className="HomePage-Header-SANTE">
        <img className="HomePage-Background" src={SanteHomepage} alt={t('heroAltSante')} />
      </div>
    )
  }

  if (isCanadaApp) {
    return (
      <div className="HomePage-Header-ELECTIONS_CANADA">
        <img className="HomePage-Background" src={CanadaHomepage} alt={t('heroAltCanada')} />
      </div>
    )
  }

  // ELECTIONS_QUEBEC (slug default / quebec2022) et fallback : hero buildings historique EQUE22
  return (
    <div className="HomePage-Header-Default">
      <img className="ImgBuildingsLeft" src={buildingsLeft} alt={t('heroAltBuildingsLeft')} />
      <img className="ImgBuildingsRight" src={buildingsRight} alt={t('heroAltBuildingsRight')} />
      <img className="ImgBot" src={datagotchiCharacter} alt={t('title')} />
      <div className="Water"></div>
    </div>
  )
}
